import styled from 'styled-components';
import { media } from '../../styles/theme';

export const Fundo = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.espaco.lg};
  background-color: ${({ theme }) => theme.cores.overlay};
  z-index: ${({ theme }) => theme.zIndex.modal};

  ${media.mobile} {
    padding: 0;
    align-items: stretch;
  }
`;

export const Caixa = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 560px;
  max-height: calc(100dvh - 32px);
  background-color: ${({ theme }) => theme.cores.card};
  border-radius: ${({ theme }) => theme.raio.card};
  box-shadow: ${({ theme }) => theme.sombra.modal};

  ${media.mobile} {
    max-width: none;
    max-height: none;
    height: 100dvh;
    border-radius: 0;
  }
`;

export const Cabecalho = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.espaco.md};
  padding: ${({ theme }) => theme.espaco.lg} ${({ theme }) => theme.espaco.xl};
  border-bottom: 1px solid ${({ theme }) => theme.cores.border};

  h3 {
    font-size: ${({ theme }) => theme.fonte.h3};
    color: ${({ theme }) => theme.cores.ink};
  }

  ${media.mobile} {
    padding: ${({ theme }) => theme.espaco.md} ${({ theme }) => theme.espaco.lg};
  }
`;

export const Corpo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.espaco.md};
  padding: ${({ theme }) => theme.espaco.xl};
  overflow-y: auto;
  flex: 1;

  ${media.mobile} {
    padding: ${({ theme }) => theme.espaco.lg};
  }
`;

export const Rodape = styled.footer`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.espaco.sm};
  padding: ${({ theme }) => theme.espaco.md} ${({ theme }) => theme.espaco.xl};
  border-top: 1px solid ${({ theme }) => theme.cores.border};

  ${media.mobile} {
    padding: ${({ theme }) => theme.espaco.md} ${({ theme }) => theme.espaco.lg};

    button {
      flex: 1;
    }
  }
`;
